import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AmplifyTour from '@amplify/amplify-tour';
import './DemoToolTips.scss';
import {
    clickSeeLessDetails,
    collapseActivitesSteps,
    customScrollTo,
    resetElementsStyles,
    updateInteraction,
} from '../../../../../utils/reading/toolTipUtils';
import { generateSteps } from '../../../../../utils/shared/demoModeUtils';
import { DEMO_TYPES, STEP } from '../../../../../constants/reading/DemoModeConstants';
import DemoCompleteModal from './DemoCompleteModal/DemoCompleteModal';

const DemoToolTips = ({
    setActiveTourStepId,
    cancelToolTip,
    updateLocation,
    setDemoType,
    exitDemoMode,
    hasTourStarted,
    activeStep,
    isGuidedTourOn,
    allResultsFetched,
    toolTips,
}) => {
    DemoToolTips.displayName = 'DemoToolTips';
    const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
    const removeModalCss = () => {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = null;
    };

    const onCancel = () => {
        cancelToolTip();
        resetElementsStyles();
    };

    const onShowCompleteModal = () => {
        setIsCompleteModalOpen(true);
        cancelToolTip();
    };

    const handleCloseCompleteModal = () => {
        setIsCompleteModalOpen(false);
        setDemoType(DEMO_TYPES.GUIDED_TOUR);
    };

    const handleGoToBenchmark = () => {
        removeModalCss();
        setIsCompleteModalOpen(false);
        exitDemoMode(true);
    };

    const onSelfExploreMode = () => {
        removeModalCss();
        setIsCompleteModalOpen(false);
        setDemoType(DEMO_TYPES.SELF_EXPLORE);
    };

    useEffect(() => {
        if (activeStep.length > 0 && isGuidedTourOn) {
            updateLocation(toolTips.steps[activeStep].location);
        }
    }, [isGuidedTourOn]);

    const onShowStep = stepId => {
        const stepData = toolTips.steps[stepId];
        if (stepId !== STEP[0] && stepId.length > 0) {
            clickSeeLessDetails(stepId);
            collapseActivitesSteps(stepId);
            customScrollTo(stepData);
            updateInteraction(stepId);
            setActiveTourStepId(stepId);
        }
    };

    const tourSteps = useMemo(() => {
        const stepIds = Object.keys(toolTips.steps);
        return generateSteps(toolTips, stepIds, {
            onShowCompleteModal,
            updateLocation,
            onShowStep,
            setActiveTourStepId,
        });
    }, []);
    return (
        <div className="layout-context-compact" id="demo-tooltips">
            <AmplifyTour
                steps={tourSteps}
                hasStarted={hasTourStarted && allResultsFetched}
                onShowStep={onShowStep}
                showStep={activeStep}
                onCancel={onCancel}
                keyboardNavigation={false}
            />
            <DemoCompleteModal
                handleClose={handleCloseCompleteModal}
                onSelfExploreMode={onSelfExploreMode}
                handleGoToBenchmark={handleGoToBenchmark}
                isCompleteModelOpen={isCompleteModalOpen}
            />
        </div>
    );
};

DemoToolTips.defaultProps = {
    activeStep: '',
    hasTourStarted: false,
    isGuidedTourOn: false,
    allResultsFetched: false,
    toolTips: {},
    setActiveTourStepId: () => {},
    cancelToolTip: () => {},
    updateLocation: () => {},
    setDemoType: () => {},
    exitDemoMode: () => {},
};

DemoToolTips.propTypes = {
    activeStep: PropTypes.string,
    hasTourStarted: PropTypes.bool,
    isGuidedTourOn: PropTypes.bool,
    allResultsFetched: PropTypes.bool,
    toolTips: PropTypes.object,
    setActiveTourStepId: PropTypes.func,
    cancelToolTip: PropTypes.func,
    updateLocation: PropTypes.func,
    setDemoType: PropTypes.func,
    exitDemoMode: PropTypes.func,
};
export default DemoToolTips;
